import { Link } from "react-router-dom";

export default function ArticleCTA() {
  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div className="relative rounded-2xl overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=A%20person%20happily%20shopping%20online%20sitting%20at%20a%20warm%20wooden%20cafe%20table%20with%20an%20open%20laptop%20displaying%20product%20images%2C%20surrounded%20by%20stylish%20shopping%20bags%20in%20neutral%20tones%20and%20a%20steaming%20latte%20art%20coffee%20cup%2C%20soft%20natural%20window%20light%20creating%20a%20warm%20inviting%20glow%2C%20cream%20walls%20with%20trailing%20plants%20in%20the%20background%20softly%20blurred%2C%20lifestyle%20photography%20capturing%20the%20joy%20of%20discovering%20great%20products%20online%2C%20cozy%20modern%20interior%20with%20brass%20accents%20and%20linen%20textures%2C%20authentic%20candid%20moment%20with%20genuine%20expression%20and%20relaxed%20atmosphere&width=1200&height=500&seq=cta-v2-fresh-2026&orientation=landscape"
            alt="Read our complete Sugargoo Spreadsheet guide"
            className="w-full h-48 md:h-64 object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-foreground-900/70 to-foreground-900/30"></div>
          <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4">
            <h2 className="font-heading text-xl md:text-3xl font-bold text-background-50 mb-3">
              Want to Master Sugargoo Shopping?
            </h2>
            <p className="text-sm md:text-base text-background-50/80 max-w-lg mb-6">
              Read our in-depth Sugargoo Spreadsheet guide covering everything from product discovery to advanced shopping strategies.
            </p>
            <Link
              to="/sugargoo-spreadsheet-guide"
              className="group inline-flex items-center gap-2 px-6 py-3 rounded-full bg-accent-500 text-background-50 text-sm md:text-base font-semibold hover:bg-accent-600 transition-all whitespace-nowrap cursor-pointer"
            >
              Read the Complete Guide
              <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
            </Link>
          </div>
        </div>

        <div className="mt-10 text-center">
          <h3 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-4">
            Ready to Start Shopping?
          </h3>
          <p className="text-sm md:text-base text-foreground-500 mb-6 max-w-xl mx-auto">
            Browse thousands of curated products on our main store. Use our Sugargoo Spreadsheet categories to find exactly what you are looking for.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="group inline-flex items-center gap-2 px-7 py-3 rounded-full bg-primary-500 text-background-50 text-sm md:text-base font-semibold hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
            >
              Sugargoo Spreadsheet
              <i className="ri-arrow-right-up-line group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="group inline-flex items-center gap-2 px-7 py-3 rounded-full border-2 border-primary-500 text-primary-600 text-sm md:text-base font-semibold hover:bg-primary-50 transition-all whitespace-nowrap cursor-pointer"
            >
              Buy It Now
              <i className="ri-shopping-bag-line group-hover:translate-x-0.5 transition-transform"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}